module.exports = __webpack_public_path__ + "img/paypal.2ca99c08.png";